module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-list"
  }, [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/teacherlist'
      }
    }
  }, [_vm._v("老师管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.currId ? "编辑老师" : "添加老师"))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main-box"
  }, [_c('Card', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formTeacher,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "老师:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formTeacher.name),
      callback: function($$v) {
        _vm.$set(_vm.formTeacher, "name", $$v)
      },
      expression: "formTeacher.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "300px"
    },
    attrs: {
      "label": "联系方式:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formTeacher.phone),
      callback: function($$v) {
        _vm.$set(_vm.formTeacher, "phone", $$v)
      },
      expression: "formTeacher.phone"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职务:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "176px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formTeacher.office),
      callback: function($$v) {
        _vm.$set(_vm.formTeacher, "office", $$v)
      },
      expression: "formTeacher.office"
    }
  }, _vm._l((_vm.officeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1)])]), _vm._v(" "), _c('Card', [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("其他信息")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formTeacher,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "800px"
    },
    attrs: {
      "rows": 5,
      "type": "textarea"
    },
    model: {
      value: (_vm.formTeacher.remark),
      callback: function($$v) {
        _vm.$set(_vm.formTeacher, "remark", $$v)
      },
      expression: "formTeacher.remark"
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "45%",
      "margin-top": "30px",
      "margin-bottom": "50px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmSubmit
    }
  }, [_vm._v("完成")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("取消")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dec3e1f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/teacher/addTeacher.vue
// module id = 702
// module chunks = 1